<script setup lang="ts">
import MeService from '@/core/shared/me/me.service';
import { computed } from 'vue';
import { ref } from 'vue';

const meService = new MeService();
const selectedEmployerId = computed(() => meService.getSelectedEmployerId());
const inputValue = ref<string>();

const employers = computed(
  () =>
    meService.userProfile?.employerUserMaps.map((e) => ({
      id: e.employerId,
      name: e.employer.name,
    })) ?? [],
);

const filteredEmployers = computed(() =>
  employers.value.filter(
    (e) => e.name?.toLowerCase().includes(inputValue.value?.toLowerCase() ?? ''),
  ),
);

function isSelectedEmployer(employerId: number) {
  return employerId === selectedEmployerId.value;
}

function changeSelectedEmployer(employerId: number) {
  const wasEmployerIdChanged = meService.setSelectedEmployerId(employerId);
  if (wasEmployerIdChanged) {
    // Use window.location.replace('/') instead of window.location.reload() to ensure:
    // 1. The URL is reset to root, avoiding invalid project/conversation IDs from the old employer
    // 2. The browser history is replaced (user can't go back to invalid employer state)
    // 3. All state is cleared and refreshed with the new employer context
    // This prevents "Conversation not found" errors when project/conversation IDs don't exist for the new employer
    window.location.replace('/');
  }
}
</script>

<template>
  <div class="flex min-h-0 flex-col">
    <div class="p-2">
      <v-text-field
        v-model="inputValue"
        placeholder="Search.."
        variant="outlined"
        density="compact"
        hide-details
        autofocus
      />
    </div>

    <div class="space-y-0.5 overflow-y-auto">
      <div
        v-for="employer in filteredEmployers"
        :key="employer.id"
        :class="{
          'menu-item h-10 cursor-pointer': true,
          'menu-row-selected font-bold': isSelectedEmployer(employer.id),
        }"
        @click="changeSelectedEmployer(employer.id)"
      >
        <span>{{ employer.name }}</span>
      </div>
    </div>
  </div>
</template>
